import { ASSET_KEY_QUERY_MAX_BYTES } from '@/features/assets/config/constants';
import { utf8ByteLength } from '@/shared/lib/utf8';

/**
 * Normalizes a raw asset-key search term to the backend `q` contract: trims
 * surrounding whitespace and returns `null` when the result is blank or exceeds
 * `ASSET_KEY_QUERY_MAX_BYTES` UTF-8 bytes.
 *
 * A `null` result means "no query": callers disable the request (or fall back to
 * the full list) rather than letting the backend answer a blank/oversized `q`
 * with a `400`. This is the single home for the `q` rule shared by the global
 * search service and the project-scoped filter.
 */
export function normalizeAssetKeyQuery(raw: string | null | undefined): string | null {
  const trimmed = (raw ?? '').trim();
  if (trimmed.length === 0) return null;
  if (utf8ByteLength(trimmed) > ASSET_KEY_QUERY_MAX_BYTES) return null;
  return trimmed;
}
